import React from 'react';

const ToursResults = () => {
  return (
    <div id="App"></div>
  );
};

export default ToursResults;
